<template>
  <div class="history-list-viewer" v-if="historyList.length">
    <div class="history-title">{{ $t('main-1.key129', { cm: '最近使用' }) }}</div>
    <div class="history-content">
      <div
        v-for="(history, index) in historyList"
        class="history-item"
        :class="{ 'full-line': index % 2 === 0 && index === historyList.length - 1 }"
        @click="selectHistory(history)"
      >
        <div class="history-item-inner" :class="{ 'has-left': index % 2 === 1 }">
          {{ history.formNameShow }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*
 */
export default {
  name: 'history-list',
  mixins: [],
  props: {
    historyList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      images: {},
    };
  },
  computed: {},
  watch: {},
  methods: {
    selectHistory(history) {
      this.$emit('selectHistory', history);
    },
  },
  mounted() {},
};
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/variable.scss';
.history-list-viewer {
  padding: 0 32px 16px 32px;
  text-align: left;

  .history-title {
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    color: #969aa2;
    margin-bottom: 10px;
  }

  .history-content {
    display: flex;
    flex-wrap: wrap;
  }

  .title {
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 40px;
    color: #969aa2;
    margin-bottom: 10px;
  }
  .history-item {
    width: 50%;
    height: 64px;
    line-height: 64px;
    text-align: center;
    margin-bottom: 24px;
    font-size: 28px;
    &.full-line {
      width: 100%;
    }
    .history-item-inner {
      background: #f9f9f9;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-word;
      border-radius: 8px;
      padding: 0 20px;
      &.has-left {
        margin-left: 24px;
      }
      &.has-right {
        margin-right: 24px;
      }
    }
  }
}
</style>
